import { CircularProgress } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { Table, Tooltip, OverlayTrigger, Modal, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import Checkbox from "../../../../components/Checkbox";
import { useIsAccessAllow } from "../../../users/redux";
import Select from "react-select";
import "../../../cold_leads/pages/cold_leads_detail/modernTable.scss";
import CallDetailsModal from "../../components/CallDetailsModal";
import {
  incomingCallsAction,
  getAllIncomingCallsAsync,
  deleteIncomingCallAsync,
  deleteSelectedIncomingCallsAsync,
} from "../../redux";
import CallDetailsButtonWithStatus from "../../../../components/CallDetailsButtonWithStatus";
import { getFailureLabel } from "../../../../utils/callFailure.util";
import { getSuccessDescriptor } from "../../../../utils/callSuccess.util";


const IncomingCallsTable = () => {
  const dispatch = useDispatch();
  const [checkedVal, setCheckedVal] = useState(false);
  const [checkIds, setCheckIds] = useState([]);
  const [callStatusCache, setCallStatusCache] = useState({});
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);
  const [callDetailsLeadId, setCallDetailsLeadId] = useState(null);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const {
    isLoading,
    incomingCallsList,
    skip,
    limit,
    searchBy,
    searchText,
    audioType,
    fromDateFilter,
    toDateFilter,
    leadType,
    callOutcomeFilter,
  } = useSelector((state) => state.incomingCalls, shallowEqual);

  const pageSizeOptions = [
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 150, label: "150" },
    { value: 200, label: "200" },
  ];

  const defaultPageSize =
    pageSizeOptions.find((option) => option.value === limit) ||
    pageSizeOptions[0];

  const changePageSize = (option) => {
    dispatch(incomingCallsAction.setLimit(option.value));
    dispatch(incomingCallsAction.setIncomingCallsBatchNumber(0));
  };

  // Helper functions for call status
  const formatTime = useCallback((ts) => {
    if (!ts) return "-";
    try {
      return new Date(ts).toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      return "-";
    }
  }, []);

  const formatDate = useCallback((ts) => {
    if (!ts) return "-";
    try {
      const d = new Date(ts);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    } catch (e) {
      return "-";
    }
  }, []);

  // const normalizeStatusText = useCallback((value) => {
  //   if (!value || typeof value !== "string") return "";
  //   const cleaned = value.replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  //   if (!cleaned) return "";
  //   return cleaned
  //     .split(" ")
  //     .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
  //     .join(" ");
  // }, []);

  // const getSuccessDescriptor = useCallback((item) => {
  //   if (!item) return "Call";
  //   const analysisStr = item.elevenlabs_analysis;
  //   if (analysisStr) {
  //     try {
  //       const analysis = JSON.parse(analysisStr);
  //       const criteria = analysis?.evaluation_criteria_results || {};
  //       const sched = criteria.call_schedule_evaluation?.result === "success";
  //       const engage = criteria.client_engagement_evaluation?.result === "success";
  //       if (sched && engage) return "Call Concluded";
  //       if (!sched && engage) return "Not Interested";
  //       if (sched && !engage) return "Call Concluded";
  //       return "Not Concluded";
  //     } catch (err) { }
  //   }
  //   return "Call";
  // }, []);

  // const getSuccessDescriptor = useCallback(
  //   (item) => {
  //     if (!item) return "Call";
  //     if (
  //       item.type === "call_initiation_failure" &&
  //       (item.failure_reason === "no-answer" ||
  //         item.failure_reason === "no answer")
  //     ) {
  //       return "Not Concluded";
  //     }
  //     if (item.voicemail_detection === true) return "Not Concluded";
  //     if (item.elevenlabs_analysis) {
  //       try {
  //         const analysis =
  //           typeof item.elevenlabs_analysis === "string"
  //             ? JSON.parse(item.elevenlabs_analysis)
  //             : item.elevenlabs_analysis;
  //         const callScheduleEval =
  //           analysis?.evaluation_criteria_results?.call_schedule_evaluation
  //             ?.result;
  //         const clientEngagementEval =
  //           analysis?.evaluation_criteria_results?.client_engagement_evaluation
  //             ?.result;
  //         if (callScheduleEval && clientEngagementEval) {
  //           const normalizedCallSchedule = String(callScheduleEval)
  //             .trim()
  //             .toLowerCase();
  //           const normalizedClientEngagement = String(clientEngagementEval)
  //             .trim()
  //             .toLowerCase();
  //           if (
  //             normalizedCallSchedule === "success" &&
  //             normalizedClientEngagement === "success"
  //           )
  //             return "Call Concluded";
  //           if (
  //             normalizedCallSchedule === "failure" &&
  //             normalizedClientEngagement === "failure"
  //           )
  //             return "Not Interested";
  //           if (
  //             normalizedCallSchedule === "failure" &&
  //             normalizedClientEngagement === "success"
  //           )
  //             return "Not Interested";
  //           return "Not Concluded";
  //         }
  //       } catch (error) { }
  //     }
  //     const message = normalizeStatusText(
  //       item?.elevenlabs_message ||
  //       item?.status_message ||
  //       item?.call_status_message,
  //     );
  //     if (message) return message;
  //     const typeDescriptor = normalizeStatusText(
  //       item?.type || item?.callOutcome || item?.status,
  //     );
  //     if (typeDescriptor) return typeDescriptor;
  //     return "Call";
  //   },
  //   [normalizeStatusText],
  // );

  const isFailureRecord = useCallback((item) => {
    return (
      item &&
      typeof item.type === "string" &&
      (item.type === "call_initiation_failure" || item.type === "call_not_connect") &&
      (String(item.call_initiation_failure || "").trim() !== "" || item.type === "call_not_connect")
    );
  }, []);

  const getCallOutcome = useCallback((item, status, isFailure) => {
    if (!item || !status) return "-";
    if (item.elevenlabs_call_outcome_status) return item.elevenlabs_call_outcome_status;
    if (isFailure) return "Not Concluded";
    return item.elevenlabs_call_outcome_status;
  }, []);

  const getCallStatus = useCallback(
    async (lead) => {
      if (!lead?._id) return null;
      const leadId = lead._id;
      if (callStatusCache[leadId]) return callStatusCache[leadId];
      try {
        const items = lead.call_ai || lead.callAi || lead.callRecords || [];
        const latestCall = Array.isArray(items) && items.length > 0 ? items[items.length - 1] : null;
        if (latestCall) {
          const isFailure = isFailureRecord(latestCall);
          const status = isFailure ? getFailureLabel(latestCall) : getSuccessDescriptor(latestCall);
          const outcome = getCallOutcome(latestCall, status, isFailure);
          const statusData = {
            status,
            outcome,
            date: formatDate(latestCall?.createdOn),
            time: formatTime(latestCall?.createdOn),
            isFailure,
          };
          setCallStatusCache((prev) => ({ ...prev, [leadId]: statusData }));
          return statusData;
        }
      } catch (error) { }
      return null;
    },
    [callStatusCache, formatDate, formatTime, getFailureLabel, getCallOutcome, isFailureRecord]
  );

  const onPageChange = (pageIndex) => {
    const nextPage = Math.max(0, pageIndex);
    dispatch(incomingCallsAction.setIncomingCallsBatchNumber(nextPage));
  };

  const onNameClick = (data) => {
    if (!data?._id) return;
    setCallDetailsLeadId(data._id);
    setIsCallModalOpen(true);
  };

  const closeCallDetailsModal = () => {
    setIsCallModalOpen(false);
  };

  const onCallDetailsClick = (data) => {
    window.open(`/incoming-calls/call-details/${data?._id}`, "_blank");
  };

  const handleSelectAll = () => {
    setCheckedVal(!checkedVal);
    if (!checkedVal) {
      setCheckIds(incomingCallsList?.records?.map((li) => li._id) || []);
    } else {
      setCheckIds([]);
    }
  };

  const handleSelectOne = (e) => {
    const { id, checked } = e.target;
    setCheckIds((prev) => (checked ? [...prev, id] : prev.filter((item) => item !== id)));
  };

  // Remove invalid leads from selectedIds when data changes
  useEffect(() => {
    if (incomingCallsList?.records && checkIds.length > 0) {
      const validIds = incomingCallsList.records
        ?.map((item) => item?._id)
        .filter(Boolean) || [];

      const hasInvalidSelected = checkIds.some((id) => !validIds.includes(id));
      if (hasInvalidSelected) {
        setCheckIds((prev) => prev.filter((id) => validIds.includes(id)));
        if (checkedVal && checkIds.length === 0) {
          setCheckedVal(false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incomingCallsList]);

  const isViewAllow = useIsAccessAllow("incomingCalls.view");
  const isCallDetailsAllow = useIsAccessAllow("incomingCalls.view");
  const isDeleteAllow = useIsAccessAllow("incomingCalls.delete");
  const isBulkDeleteAllow = useIsAccessAllow("incomingCalls.multiple_delete");
  const hasSelection = checkIds.length > 0;

  const getLeadTypeStyle = (leadType) => {
    switch (leadType?.toLowerCase()) {
      case "genuine":
        return { color: "#28a745", fontWeight: "500" };
      case "promotional":
        return { color: "#007bff", fontWeight: "500" };
      case "spam":
        return { color: "#dc3545", fontWeight: "500" };
      default:
        return { color: "#6c757d", fontWeight: "500" };
    }
  };

  const formatLeadType = (lt) => {
    if (!lt) return "-";
    return lt.charAt(0).toUpperCase() + lt.slice(1).toLowerCase();
  };

  const onDeleteClick = (data) => {
    if (!data?._id) return;
    setDeleteTarget({ type: "single", leadId: data._id });
    setIsDeleteConfirmOpen(true);
  };

  const onDeleteSelected = () => {
    if (!checkIds.length) return;
    setDeleteTarget({ type: "bulk" });
    setIsDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (!deleteTarget) return;

    if (deleteTarget.type === "single" && deleteTarget.leadId) {
      dispatch(deleteIncomingCallAsync(deleteTarget.leadId)).then(() => {
        dispatch(getAllIncomingCallsAsync(searchBy, searchText, audioType, fromDateFilter, toDateFilter, leadType, callOutcomeFilter));
      });
    } else if (deleteTarget.type === "bulk" && checkIds.length) {
      dispatch(deleteSelectedIncomingCallsAsync(checkIds)).then(() => {
        setCheckedVal(false);
        setCheckIds([]);
        dispatch(getAllIncomingCallsAsync(searchBy, searchText, audioType, fromDateFilter, toDateFilter, leadType, callOutcomeFilter));
      });
    }

    setIsDeleteConfirmOpen(false);
    setDeleteTarget(null);
  };

  const handleDeleteCancel = () => {
    setIsDeleteConfirmOpen(false);
    setDeleteTarget(null);
  };

  const totalRecords = incomingCallsList?.recordsTotal || 0;
  const totalPages = Math.ceil(totalRecords / (limit || 1));
  const currentPage = skip + 1;

  return (
    <>
      <div
        className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position"
        style={{
          background: "#ffffff",
          borderRadius: "12px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 180px)",
          minHeight: "600px",
        }}
      >
        <div
          className="tblmrgn mt-0"
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto",
            minHeight: 0,
          }}
        >
          {isBulkDeleteAllow && (
            <div className="mt-4 mb-4" style={{ flex: "0 0 auto" }}>
              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                {isBulkDeleteAllow && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="bulk-delete-tooltip">Delete</Tooltip>}
                  >
                    <button
                      type="button"
                      className="custom-action-button button-danger"
                      disabled={!hasSelection}
                      onClick={onDeleteSelected}
                      style={{ minWidth: "40px", padding: "8px" }}
                    >
                      <span className="svg-icon" style={{ color: "#ffffff" }}>
                        <SVG src={toAbsoluteUrl("/media/svg/icons/custom/delete.svg")} height={20} width={20} />
                      </span>
                    </button>
                  </OverlayTrigger>
                )}
              </div>
            </div>
          )}
          <div
            className="table-container-wrapper"
            style={{ flex: "1 1 auto", minHeight: 0 }}
          >
            <div className="table-scroll-container">
              <Table hover className="mb-0 modern-table">
                <thead>
                  <tr>
                    {isBulkDeleteAllow && (
                      <th style={{ width: "50px", minWidth: "50px", maxWidth: "50px", whiteSpace: "nowrap" }}>
                        <label className="custom-checkbox-wrapper">
                          <Checkbox
                            type="checkbox"
                            name="checkAll"
                            id="checkAll"
                            handleClick={handleSelectAll}
                            isChecked={checkedVal}
                          />
                          <span className="custom-checkbox"></span>
                        </label>
                      </th>
                    )}
                    <th
                      style={{
                        width: "70px",
                        minWidth: "70px",
                        maxWidth: "70px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Sr No.
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>Name</th>
                    <th style={{ whiteSpace: "nowrap" }}>Country</th>
                    <th style={{ whiteSpace: "nowrap" }}>Email</th>
                    <th style={{ whiteSpace: "nowrap" }}>Project Requirement</th>
                    <th style={{ whiteSpace: "nowrap" }}>Last Inquiry</th>
                    <th style={{ whiteSpace: "nowrap" }}>Created On</th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        width: "200px",
                        minWidth: "200px",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading &&
                    incomingCallsList?.records &&
                    incomingCallsList.records.length ? (
                    incomingCallsList.records.map((lead, index) => (
                      <tr key={lead._id || index}>
                        {isBulkDeleteAllow && (
                          <td style={{ width: "50px", minWidth: "50px", maxWidth: "50px", whiteSpace: "nowrap" }}>
                            <label className="custom-checkbox-wrapper">
                              <Checkbox
                                type="checkbox"
                                name={lead?._id}
                                id={lead?._id}
                                handleClick={handleSelectOne}
                                isChecked={checkIds.includes(lead?._id)}
                              />
                              <span className="custom-checkbox"></span>
                            </label>
                          </td>
                        )}
                        <td
                          style={{
                            width: "70px",
                            minWidth: "70px",
                            maxWidth: "70px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>{skip * limit + (index + 1)}</span>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {isCallDetailsAllow &&
                            lead &&
                            lead.elevenlabs_call_ai_id &&
                            lead.elevenlabs_conversation_id ? (
                            <button
                              type="button"
                              onClick={() => onNameClick(lead)}
                              className="profile-name clickable-name"
                              style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                margin: 0,
                                color: "#3b82f6",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "inherit",
                                fontWeight: "inherit",
                              }}
                            >
                              {lead.name || "-"}
                            </button>
                          ) : (
                            <span className="profile-name">
                              {lead.name || "-"}
                            </span>
                          )}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <div style={{ display: "flex", flexDirection: "column" }}>
                            <span className="f-w-500">{lead?.countryName || "-"}
                              <br />{lead?.timeZone ? lead?.timeZone : " -"}</span>
                            <span className="f-w-500" style={{ fontSize: "0.875rem", color: "#6b7280" }}>
                              {lead?.currentCountryTime || "-"}

                            </span>
                          </div>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span>{lead.email || "-"}</span>
                          </div>
                          {lead.contactNumber && (
                            <div
                              style={{
                                fontSize: 12,
                                color: "#6b7280",
                                marginTop: "2px",
                              }}
                            >
                              {lead.contactNumber}
                            </div>
                          )}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {lead.pro_requirements ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip
                                  id={`req-${lead?._id || index}`}
                                >
                                  {lead.pro_requirements}
                                </Tooltip>
                              }
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  maxWidth: "300px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  verticalAlign: "middle",
                                  cursor: "help",
                                }}
                              >
                                {lead.pro_requirements}
                              </span>
                            </OverlayTrigger>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td style={{ whiteSpace: "nowrap", textTransform: "capitalize" }}>
                          <span>
                            {lead.lastInquiryType
                              ? lead.lastInquiryType
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase())
                              : "-"}
                          </span>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <span>
                            {lead?.createdOn
                              ? (() => {
                                const d = new Date(lead.createdOn);
                                const dd = String(d.getDate()).padStart(2, "0");
                                const mm = String(d.getMonth() + 1).padStart(2, "0");
                                const yy = String(d.getFullYear()).slice(-2);
                                const time = d.toLocaleTimeString(undefined, {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                });
                                return `${dd}/${mm}/${yy} ${time}`;
                              })()
                              : "-"}
                          </span>
                        </td>
                        <td
                          style={{
                            whiteSpace: "nowrap",
                            textAlign: "left",
                            width: "200px",
                            minWidth: "200px",
                          }}
                        >
                          <div className="inline-actions">
                            {isCallDetailsAllow &&
                              lead &&
                              lead.elevenlabs_call_ai_id &&
                              lead.elevenlabs_conversation_id && (
                                <CallDetailsButtonWithStatus
                                  lead={lead}
                                  onCallDetailsPageClick={onCallDetailsClick}
                                  getCallStatus={getCallStatus}
                                />
                              )}
                            {isDeleteAllow && (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`delete-tooltip-${lead?._id || index}`}>
                                    Delete Lead
                                  </Tooltip>
                                }
                              >
                                <button
                                  type="button"
                                  className="inline-action-btn danger"
                                  onClick={() => onDeleteClick(lead)}
                                >
                                  <span className="svg-icon svg-icon-danger">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/custom/delete.svg")} height={20} width={20} />
                                  </span>
                                </button>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={isBulkDeleteAllow ? 9 : 8} className="text-center">
                        {isLoading ? "Loading..." : "No Record Found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          {!isLoading && (
            <div className="modern-pagination" style={{ flex: "0 0 auto" }}>
              <div
                className="pagination-info"
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <span style={{ fontSize: "14px", color: "#6b7280" }}>Show</span>
                  <Select
                    classNamePrefix="react-select"
                    value={defaultPageSize}
                    options={pageSizeOptions}
                    onChange={changePageSize}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      container: (base) => ({ ...base, width: 90 }),
                      control: (base, state) => ({
                        ...base,
                        minHeight: 36,
                        height: 36,
                        borderColor: state.isFocused ? "#6993FF" : "#d1d5db",
                        boxShadow: state.isFocused ? "0 0 0 3px rgba(105, 147, 255, 0.1)" : "none",
                        "&:hover": { borderColor: "#6993FF" },
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 10px",
                        height: 36,
                        display: "flex",
                        alignItems: "center",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: 13,
                        fontWeight: 500,
                        color: "#111827",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                      dropdownIndicator: (base, state) => ({
                        ...base,
                        padding: 6,
                        color: state.isFocused ? "#6993FF" : "#6b7280",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: 13,
                        padding: "8px 10px",
                        backgroundColor: state.isSelected
                          ? "#6993FF"
                          : state.isFocused
                            ? "#f3f4f6"
                            : "#fff",
                        color: state.isSelected ? "#fff" : "#111827",
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
                Showing{" "}
                {incomingCallsList?.records && incomingCallsList.records.length
                  ? skip * limit + 1
                  : 0}{" "}
                to{" "}
                {incomingCallsList?.records && incomingCallsList.records.length
                  ? Math.min(
                    skip * limit + incomingCallsList.records.length,
                    totalRecords
                  )
                  : 0}{" "}
                of {totalRecords} entries
              </div>
              <div className="pagination-controls">
                <button
                  className="page-btn"
                  onClick={() => onPageChange(skip - 1)}
                  disabled={skip === 0}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path
                      d="M10 12L6 8l4-4"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                {(() => {
                  const pages = [];
                  if (totalPages > 0) pages.push(1);
                  for (
                    let i = Math.max(2, currentPage - 1);
                    i <= Math.min(totalPages - 1, currentPage + 1);
                    i++
                  ) {
                    if (!pages.includes(i)) pages.push(i);
                  }
                  if (totalPages > 1 && !pages.includes(totalPages))
                    pages.push(totalPages);
                  return pages.map((page, idx) => {
                    const showEllipsisBefore =
                      idx > 0 && page - pages[idx - 1] > 1;
                    return (
                      <React.Fragment key={page}>
                        {showEllipsisBefore && (
                          <span style={{ padding: "0 4px" }}>...</span>
                        )}
                        <button
                          className={`page-btn ${currentPage === page ? "active" : ""}`}
                          onClick={() => onPageChange(page - 1)}
                        >
                          {page}
                        </button>
                      </React.Fragment>
                    );
                  });
                })()}
                <button
                  className="page-btn"
                  onClick={() => onPageChange(skip + 1)}
                  disabled={(skip + 1) * limit >= totalRecords}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path
                      d="M6 12l4-4-4-4"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}
          {isLoading && (
            <div style={{ flex: "0 0 auto" }}>
              <div style={{ justifyContent: "center" }} className="text-center">
                <div className="basic-verification-loader text-center">
                  <CircularProgress />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <CallDetailsModal
        show={isCallModalOpen}
        onHide={closeCallDetailsModal}
        leadId={callDetailsLeadId}
      />
      <Modal
        show={isDeleteConfirmOpen}
        onHide={handleDeleteCancel}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteTarget?.type === "bulk"
            ? `Are you sure you want to delete ${checkIds.length} selected Incoming Calls(s)?`
            : "Are you sure you want to delete this Incoming Calls?"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteCancel}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default IncomingCallsTable;